export default function PeriodNav({ label, onPrev, onNext, atLatest, right }) {
  return (
    <div className="periodnav">
      <button className="ghost" onClick={onPrev} title="Earlier">
        ‹
      </button>
      <span className="periodnav-label">{label}</span>
      <button className="ghost" onClick={onNext} disabled={atLatest} title="Later">
        ›
      </button>
      {right && <span className="periodnav-right">{right}</span>}
    </div>
  );
}
